
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "RecommendTitle",
  props: {
    /**
     * タイトル
     */
    title: {
      type: String,
      default: "",
      required: true
    },
    /**
     * レシピ種別
     */
    type: {
      type: String,
      default: "",
      required: true
    },
    seeMoreEnable: {
      type: Boolean,
      default: true,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("setup title=" + props.title + " seeMoreEnable=" + props.seeMoreEnable);
    /**
     * 「もっと見る」タッチを通知する
     */
    const clickSeeMore = () => {
      NativeClient.sendDebugLog("clickSeeMore props.type=" + props.type + " props.seeMoreEnable=" + props.seeMoreEnable);
      if (props.seeMoreEnable) {
        context.emit("select-see-more", props.type);
      }
    };

    const getSeeMoreFontColor = () => {
      return getComputedStyle(document.documentElement).getPropertyValue(
        props.seeMoreEnable ? "--main-text-color" : "--main-disable-text-color"
      );
    }
    return {
      clickSeeMore,
      getSeeMoreFontColor
    };
  }
});
